const initialState = {
  isLoading: false,
}

export default function dashboardAzubi(state = initialState) {
  return state
}
